import "../../src/assets/styles/Header.css";
import logo from "../imgs/logo.png";
import iconBackCircle from "../imgs/figma_icons/icon-back-circle.png";
import { useNavigate } from "react-router-dom";

function Header({ isPageSearch, pageToAcction, data, webSetting }) {
  const navigate = useNavigate();
  const backToSearch = () => {
    if (pageToAcction) navigate(pageToAcction, { state: data });
    else navigate("/");
  };

  const logoSrc = webSetting?.logo || webSetting?.logoMb || logo;

  return (
    <div className="header-wrapper">
      <div className="status-bar-spacer"></div>
      <div className="header">
        {!isPageSearch && (
          <button
            type="button"
            className="btn-back-circle"
            id="btn-back"
            onClick={backToSearch}
            aria-label="Quay lại"
          >
            <img
              src={iconBackCircle}
              alt="Quay lại"
            />
          </button>
        )}
        <div className="main-logo" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
          <img src={logoSrc} alt="SHBET Logo" />
        </div>
      </div>
    </div>
  );
}

export default Header;
